// extracted by mini-css-extract-plugin
export default {"loginCardWrapper":"styles_loginCardWrapper__qbDty"};